"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.repaymentStatus = exports.repaymentTypes = void 0;
exports.repaymentTypes = {
  SIMPLE_INTEREST: "SIMPLE_INTEREST",
  COMPOUND_INTEREST: "COMPOUND_INTEREST"
};
exports.repaymentStatus = {
  PAID: "PAID",
  PENDING: "PENDING"
};